import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper
} from '@mui/material';
import {
  WarningAmber,
  DeleteForever as DeleteIcon
} from '@mui/icons-material';

// Рендерится карточкой только при canDelete (users.delete, ранг 100)
interface UserDangerZoneSectionProps {
  onOpenDeleteModal: () => void;
}

export const UserDangerZoneSection: React.FC<UserDangerZoneSectionProps> = ({
  onOpenDeleteModal
}) => {
  return (
    <Box id="user-section-danger" sx={{ scrollMarginTop: '60px' }}>
      <Paper
        elevation={0}
        sx={{
          p: 3.5,
          borderRadius: '16px',
          bgcolor: '#fff1f2',
          border: '1px solid #fecdd3',
          boxShadow: '0 2px 10px rgba(225, 29, 72, 0.04)'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
          <WarningAmber sx={{ color: '#e11d48' }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#9f1239' }}>
            Опасная зона (Danger Zone)
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ color: '#be123c', mb: 3 }}>
          Удаление пользователя необратимо: будут удалены все его данные, персональная таблица отчетов, сессии почты и привязки.
        </Typography>

        <Button
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onOpenDeleteModal}
          sx={{
            bgcolor: '#e11d48',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { bgcolor: '#be123c' }
          }}
        >
          Удалить пользователя навсегда
        </Button>
      </Paper>
    </Box>
  );
};

export default UserDangerZoneSection;
